/* eslint-disable camelcase */
// import { isEmpty } from 'lodash';
import { type UseMutationResult, useMutation, useQueryClient } from 'react-query';
import { toast } from 'react-toastify';
import ToastComponent from '../../components/toast';
import {
  ReleaseService,
  Wealthlane_AwardService_Dtos_Release_CreateReleaseDto,
  Wealthlane_AwardService_Dtos_Release_UpdateReleaseDto,
} from '../../services/wealthlane-award-services';
import { ReleaseFilterService } from '../../services/wealthlane-award-services/services/ReleaseFilterService';

const usePostTransactionAddToRelease = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  selectedTableData?: any,
  setSelectedId?: any,
  setNumberOfInclude?: any,
  numberOfInclude?: any,
  modalStatus?: string,
  releaseId?: any,
  setSelectedTableData?: any,
  selectedId?: string,
  setInitialValue?: any,
  filter?: any,
  isSelectAllActive?: boolean,
  openSubmitModal?: () => void,
  setTaskReferenceNo?: any,
  totalCount?: number,
  uncheckedIds?: string[]
): UseMutationResult<
  | Wealthlane_AwardService_Dtos_Release_CreateReleaseDto
  | Wealthlane_AwardService_Dtos_Release_UpdateReleaseDto
  | undefined,
  unknown,
  any,
  unknown
> => {
  const queryClient = useQueryClient();

  return useMutation(
    async (payload: any) => {
      // debugger;
      const newPayload = {
        ...payload,
        isRemoveItem: false,
        // vesting: selectedTableData ? selectedTableData : [],
      };
      const {
        filter: searchKeyWord,
        createdFromDate,
        createdToDate,
        grantName,
        ...restFilter
      } = filter || {};
      const transformedFilter = {
        ...restFilter,
        searchKeyWord,
        grantId: grantName,
        fromDate: createdFromDate,
        toDate: createdToDate,
      };

      if (modalStatus === 'Edit' || selectedId) {
        return await handleRequest(
          isSelectAllActive
            ? ReleaseFilterService.putApiAwardApiAppReleaseFilterReleaseByFilter({
                releaseId: releaseId ? releaseId : selectedId,
                ...newPayload,
                filter: transformedFilter,
                deselectedIds: uncheckedIds,
              })
            : ReleaseService.putApiAwardApiAppReleaseRelease(releaseId ? releaseId : selectedId, {
                ...newPayload,
                vesting: selectedTableData ? selectedTableData : [],
              })
        );
      } else {
        return await handleRequest(
          isSelectAllActive
            ? ReleaseFilterService.postApiAwardApiAppReleaseFilterReleaseByFilter({
                ...newPayload,
                filter: transformedFilter,
                deselectedIds: uncheckedIds,
              })
            : ReleaseService.postApiAwardApiAppReleaseRelease({
                ...newPayload,
                vesting: selectedTableData ? selectedTableData : [],
              })
        );
      }
    },
    {
      onSuccess: async (response: any) => {
        if (response != null) {
          if (response.sentToBackground === true) {
            openSubmitModal();
            setTaskReferenceNo(response.taskReferenceNo);
          } else {
            // Set initial value and selected id
            const addedCount = isSelectAllActive
              ? (totalCount ?? 0) - (uncheckedIds?.length ?? 0)
              : selectedTableData.length;
            toast.success(
              <ToastComponent
                label='Success'
                message={`${addedCount} items added to the release.`}
              />
            );
          }
          setInitialValue(response);
          setSelectedId(response?.id);
          await queryClient.invalidateQueries('getTransactionReleaseRsuVestingList');

          const addedItemCount = isSelectAllActive
            ? (totalCount ?? 0) - (uncheckedIds?.length ?? 0)
            : selectedTableData.length;
          if (numberOfInclude) {
            setNumberOfInclude(numberOfInclude + addedItemCount);
          } else {
            setNumberOfInclude(addedItemCount);
          }

          setSelectedTableData([]);
        } else {
          setSelectedTableData([]);
        }
      },
      onError: (err) => {
        setSelectedTableData([]);
      },
    }
  );
};

export default usePostTransactionAddToRelease;
